// File: assets/aishas-hotspot-look.js

(function () {
  function initSection(sectionEl) {
    if (!sectionEl || sectionEl.dataset.aishasHotspotInit === "true") return;

    const slidesViewport = sectionEl.querySelector(".aishas-slider");
    const slidesContainer = sectionEl.querySelector(".slides");
    const prev = sectionEl.querySelector(".aishas-prev");
    const next = sectionEl.querySelector(".aishas-next");
    const dots = Array.from(sectionEl.querySelectorAll(".dot-nav"));
    const hotspots = Array.from(sectionEl.querySelectorAll(".aishas-hotspot"));

    if (!slidesContainer || !prev || !next) return;

    function getVisibleCount() {
      return 1;
    }

    let visible = getVisibleCount();

    function applyVisible() {
      sectionEl.style.setProperty("--aishas-visible", String(visible));
    }

    const realSlides = Array.from(slidesContainer.querySelectorAll(".slide"));
    const total = realSlides.length;

    if (total === 0) return;

    sectionEl.dataset.aishasHotspotInit = "true";

    // Tail clone is only needed for multi-visible layouts.
    if (visible > 1 && total > 1) {
      const tailClone = realSlides[0].cloneNode(true);
      tailClone.classList.add("is-clone");
      tailClone.setAttribute("aria-hidden", "true");
      slidesContainer.appendChild(tailClone);
    }

    let pageStart = 0;

    function setTransition(on) {
      slidesContainer.style.transition = on ? "transform 0.4s ease" : "none";
    }

    function setPosition() {
      slidesContainer.style.transform = `translateX(-${pageStart * (100 / visible)}%)`;
    }

    function setActiveDotByIndex(realIndex) {
      dots.forEach((d) => d.classList.remove("active"));
      if (dots[realIndex]) dots[realIndex].classList.add("active");
    }

    function getPageStartForProduct(productIndex) {
      return ((productIndex % total) + total) % total;
    }

    const directionVectors = {
      n: { x: 0, y: -1 },
      ne: { x: Math.SQRT1_2, y: -Math.SQRT1_2 },
      e: { x: 1, y: 0 },
      se: { x: Math.SQRT1_2, y: Math.SQRT1_2 },
      s: { x: 0, y: 1 },
      sw: { x: -Math.SQRT1_2, y: Math.SQRT1_2 },
      w: { x: -1, y: 0 },
      nw: { x: -Math.SQRT1_2, y: -Math.SQRT1_2 }
    };

    function getDirection(hotspot) {
      const raw = (hotspot.dataset.direction || "auto").toLowerCase();
      return directionVectors[raw] ? raw : "auto";
    }

    function getLineLength(hotspot) {
      const value = Number(hotspot.dataset.lineLength);
      if (!Number.isFinite(value)) return 28;
      return Math.max(8, Math.min(120, value));
    }

    function getManualPlacement(direction, width, height, lineLength) {
      const vec = directionVectors[direction];
      const gap = 8;
      const endX = vec.x * lineLength;
      const endY = vec.y * lineLength;

      switch (direction) {
        case "e":
          return { x: endX + gap, y: -height / 2, vec };
        case "w":
          return { x: endX - width - gap, y: -height / 2, vec };
        case "n":
          return { x: -width / 2, y: endY - height - gap, vec };
        case "s":
          return { x: -width / 2, y: endY + gap, vec };
        case "ne":
          return { x: endX + gap, y: endY - height - gap, vec };
        case "nw":
          return { x: endX - width - gap, y: endY - height - gap, vec };
        case "se":
          return { x: endX + gap, y: endY + gap, vec };
        case "sw":
          return { x: endX - width - gap, y: endY + gap, vec };
        default:
          return null;
      }
    }

    function resolveHotspotLabelOverlaps() {
      if (!hotspots.length) return;

      const containerRect = sectionEl.querySelector(".aishas-left")?.getBoundingClientRect();
      if (!containerRect) return;

      const gap = 16;
      const placements = [];

      const items = hotspots
        .map((hotspot) => {
          const label = hotspot.querySelector(".label");
          if (!label) return null;
          return { hotspot, label };
        })
        .filter(Boolean)
        .sort((a, b) => {
          const aTop = a.hotspot.offsetTop;
          const bTop = b.hotspot.offsetTop;
          if (aTop !== bTop) return aTop - bTop;
          return a.hotspot.offsetLeft - b.hotspot.offsetLeft;
        });

      items.forEach(({ hotspot, label }) => {
        const pinRect = hotspot.getBoundingClientRect();
        const pinX = pinRect.left - containerRect.left;
        const pinY = pinRect.top - containerRect.top;
        const width = label.offsetWidth;
        const height = label.offsetHeight;
        const direction = getDirection(hotspot);
        const baseLineLength = getLineLength(hotspot);

        let use;
        let manualVec = null;

        if (direction !== "auto") {
          const manual = getManualPlacement(direction, width, height, baseLineLength);
          manualVec = manual.vec;
          use = {
            x: manual.x,
            y: manual.y,
            rect: {
              left: pinX + manual.x,
              top: pinY + manual.y,
              right: pinX + manual.x + width,
              bottom: pinY + manual.y + height
            }
          };
        } else {
          const d = baseLineLength + 8;
          const candidates = [
            { x: d, y: -height / 2 },
            { x: -width - d, y: -height / 2 },
            { x: -width / 2, y: d },
            { x: -width / 2, y: -height - d },
            { x: d, y: d },
            { x: -width - d, y: d },
            { x: d, y: -height - d },
            { x: -width - d, y: -height - d }
          ];

          let chosen = null;
          let fallback = null;

          for (let i = 0; i < candidates.length; i += 1) {
            const c = candidates[i];
            const rect = {
              left: pinX + c.x,
              top: pinY + c.y,
              right: pinX + c.x + width,
              bottom: pinY + c.y + height
            };

            const inBounds =
              rect.left >= 0 &&
              rect.top >= 0 &&
              rect.right <= containerRect.width &&
              rect.bottom <= containerRect.height;

            const collides = placements.some(
              (p) =>
                rect.left < p.right + gap &&
                rect.right > p.left - gap &&
                rect.top < p.bottom + gap &&
                rect.bottom > p.top - gap
            );

            if (!fallback || (!collides && inBounds)) fallback = { ...c, rect };
            if (inBounds && !collides) {
              chosen = { ...c, rect };
              break;
            }
          }

          use = chosen || fallback || { x: d, y: -height / 2, rect: null };
        }

        const minX = -pinX;
        const maxX = containerRect.width - pinX - width;
        const minY = -pinY;
        const maxY = containerRect.height - pinY - height;
        const finalX = Math.max(minX, Math.min(use.x, maxX));
        const finalY = Math.max(minY, Math.min(use.y, maxY));

        label.style.setProperty("--label-x", `${Math.round(finalX)}px`);
        label.style.setProperty("--label-y", `${Math.round(finalY)}px`);

        let lineDx;
        let lineDy;
        let lineLength;
        let lineAngle;

        if (manualVec) {
          lineDx = manualVec.x * baseLineLength;
          lineDy = manualVec.y * baseLineLength;
          lineLength = baseLineLength;
          lineAngle = Math.atan2(lineDy, lineDx) * (180 / Math.PI);
        } else {
          const labelLeft = finalX;
          const labelTop = finalY;
          const labelRight = finalX + width;
          const labelBottom = finalY + height;
          const nearestX = Math.max(labelLeft, Math.min(0, labelRight));
          const nearestY = Math.max(labelTop, Math.min(0, labelBottom));
          lineDx = nearestX;
          lineDy = nearestY;
          lineLength = Math.sqrt(lineDx * lineDx + lineDy * lineDy);
          lineAngle = Math.atan2(lineDy, lineDx) * (180 / Math.PI);
          if (lineLength < baseLineLength) lineLength = baseLineLength;
        }

        hotspot.style.setProperty("--line-length", `${Math.max(0, Math.round(lineLength))}px`);
        hotspot.style.setProperty("--line-angle", `${lineAngle}deg`);

        placements.push(
          use.rect || {
            left: pinX + finalX,
            top: pinY + finalY,
            right: pinX + finalX + width,
            bottom: pinY + finalY + height
          }
        );
      });
    }

    function goToPageStart(targetStart) {
      if (total <= 0) return;
      const nextStart = ((targetStart % total) + total) % total;
      if (nextStart === pageStart) {
        setActiveDotByIndex(pageStart);
        return;
      }

      setTransition(true);
      pageStart = nextStart;
      setPosition();
      setActiveDotByIndex(pageStart);
    }

    // Initial position
    applyVisible();
    setTransition(false);
    setPosition();
    setActiveDotByIndex(0);
    resolveHotspotLabelOverlaps();
    window.setTimeout(resolveHotspotLabelOverlaps, 150);

    next.addEventListener("click", function () {
      goToPageStart(pageStart + 1);
    });

    prev.addEventListener("click", function () {
      goToPageStart(pageStart - 1);
    });

    // Dots: always clickable (fixes "3. dot not clickable")
    dots.forEach((d) => {
      d.addEventListener("click", function () {
        const target = Number(this.dataset.index);
        if (Number.isFinite(target)) goToPageStart(getPageStartForProduct(target));
      });
    });

    // Hotspots: click -> go to that product "state"
    hotspots.forEach((h) => {
      h.addEventListener("click", function () {
        const target = Number(this.dataset.slideIndex);
        if (Number.isFinite(target)) goToPageStart(getPageStartForProduct(target));
      });
    });

    // Optional: swipe (mobile)
    let startX = null;
    slidesViewport?.addEventListener(
      "touchstart",
      (e) => {
        if (!e.touches || e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
      },
      { passive: true }
    );

    slidesViewport?.addEventListener(
      "touchend",
      (e) => {
        if (startX == null) return;
        const endX = e.changedTouches && e.changedTouches[0] ? e.changedTouches[0].clientX : startX;
        const diff = endX - startX;
        startX = null;

        // threshold
        if (Math.abs(diff) < 40) return;
        if (diff < 0) next.click();
        else prev.click();
      },
      { passive: true }
    );

    let resizeRaf = null;
    window.addEventListener("resize", function () {
      if (resizeRaf) cancelAnimationFrame(resizeRaf);
      resizeRaf = requestAnimationFrame(() => {
        const nextVisible = getVisibleCount();
        if (nextVisible !== visible) {
          visible = nextVisible;
          applyVisible();
          setTransition(false);
          setPosition();
          setActiveDotByIndex(pageStart);
        }
        resolveHotspotLabelOverlaps();
      });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll("[data-aishas-section]").forEach(initSection);
  }

  document.addEventListener("DOMContentLoaded", function () {
    initAll(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
